module.exports = __webpack_public_path__ + "static/media/Cropped_Twodash_blue.290ad5b2.svg";